var _rect, _ellipse, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductCompost(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "#f2f6f0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 700,
    rx: 220,
    ry: 30,
    fill: "#0e6838",
    opacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-170,-220 C-190,-220 -200,-190 -195,-150 L-150,240 C-145,270 -120,290 -80,290 L80,290 C120,290 145,270 150,240 L195,-150 C200,-190 190,-220 170,-220 Z",
    fill: "#8a6242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-170,-220 C-190,-220 -200,-190 -195,-150 L-185,-70 L185,-70 L195,-150 C200,-190 190,-220 170,-220 Z",
    fill: "#6b4a33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -150,
    y: -260,
    width: 300,
    height: 70,
    rx: 16,
    fill: "#0e6838"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -215,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 34,
    fill: "#fff",
    fontWeight: 700
  }, "COMPOST"), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 80,
    r: 90,
    fill: "#eef0e1",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40,90 C-20,40 20,40 40,90 C55,120 30,150 0,150 C-30,150 -55,120 -40,90 Z",
    fill: "#2f9457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,90 C4,50 -4,10 0,-30",
    stroke: "#1c7a45",
    strokeWidth: 8,
    fill: "none",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCompost);
export default __webpack_public_path__ + "static/media/product-compost.31a37899537b13037acecd29f8d7358b.svg";
export { ForwardRef as ReactComponent };